import{validateEmailAddress as t}from"../internal/emailAddressValidation.js";class r{constructor(r){this.val=r,t(r)}toString(){return this.val}}export{r as EmailAddress};
